import { render } from "./limitedAvailabilityMessage.vue?vue&type=template&id=1f3d3a89"
import script from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js"
export * from "./limitedAvailabilityMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__